import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset! Please sign in.");
      navigate("/account");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-20">
      <div className="dw-card rounded-2xl p-8">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#00F0FF]/10"><Lock className="h-6 w-6 text-[#00F0FF]" /></div>
        <h1 className="font-display mt-5 text-2xl font-bold text-white">Set a new password</h1>
        {!token ? (
          <p className="mt-3 text-sm text-[#FF2A6D]" data-testid="reset-no-token">Invalid or missing reset link.</p>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div><Label className="text-slate-300">New Password</Label><Input required type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 border-white/10 bg-white/5" data-testid="reset-password" placeholder="••••••••" /></div>
            {error && <p className="text-sm text-[#FF2A6D]">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full rounded-xl bg-[#00F0FF] py-6 font-bold text-[#08090E] hover:bg-[#33F3FF]" data-testid="reset-submit">{loading ? "Saving…" : "Reset password"}</Button>
          </form>
        )}
        <Link to="/account" className="mt-5 inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-[#00F0FF]" data-testid="reset-back"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
      </div>
    </div>
  );
}
